import React from "react";

import { ArrowOrEqualIcon } from "../../common/arrowOrEqualIcon/ArrowOrEqualIcon";

export function TabelaSaldosFatura(props) {
    const icon = (
        <ArrowOrEqualIcon
            iconName={
                props.item.saldo_geracao > props.item.saldo_geracao_mes_anterior
                    ? "arrowUpGreen"
                    : props.item.saldo_geracao < props.item.saldo_geracao_mes_anterior
                      ? "arrowDownRed"
                      : props.item.saldo_geracao == props.item.saldo_geracao_mes_anterior
                        ? "equalBlue"
                        : null
            }
        />
    );

    if (props.pillMode) {
        return [1, 4].includes(props.item.id_grupo_faturamento) ? (
            <div style={{ fontSize: "0.8rem", padding: 5 }}>
                <div
                    className="d-flex align-items-center px-2 py-1"
                    style={{ width: "100%", textAlign: "center", backgroundColor: "#ECECEC", fontWeight: "bolder", color: "#353535", borderRadius: "0.3rem 0.3rem 0 0" }}
                >
                    <span style={{ width: 130 }}>Saldo P </span>
                    <span className="pl-2 pr-1" style={{ width: "100%", textAlign: "right" }}>{`${Math.round(props.item.saldo_geracao_ponta || 0)} kWh`}</span>
                    {icon}
                </div>
                <div
                    className="d-flex align-items-center px-2 py-1"
                    style={{ width: "100%", textAlign: "center", backgroundColor: "#ECECEC", fontWeight: "bolder", color: "#353535" }}
                >
                    <span style={{ width: 130 }}>Saldo FP </span>
                    <span className="pl-2 pr-1" style={{ width: "100%", textAlign: "right" }}>{`${Math.round(props.item.saldo_geracao_fora_ponta || 0)} kWh`}</span>
                    {icon}
                </div>
                <div
                    className="d-flex align-items-center px-2 py-1"
                    style={{ width: "100%", textAlign: "center", backgroundColor: "#cdcdcd", fontWeight: "bolder", color: "#353535", borderRadius: "0 0 0.3rem 0.3rem" }}
                >
                    <span style={{ width: 130 }}>Saldo Total </span>
                    <span className="pl-2 pr-1" style={{ width: "100%", textAlign: "right" }}>{`${Math.round(props.item.saldo_geracao || 0)} kWh`}</span>
                    {icon}
                </div>
            </div>
        ) : (
            <div
                className="d-flex justify-content-center align-items-center px-2 py-1"
                style={{ width: "100%", textAlign: "center", backgroundColor: "#ECECEC", borderRadius: "0.3rem", fontWeight: "bolder", color: "#353535" }}
            >
                <span>Saldo </span>
                <span className="pl-2 pr-1" style={{ fontSize: "0.8rem" }}>{`${Math.round(props.item.saldo_geracao || 0)} kWh`}</span>
                {icon}
            </div>
        );
    }

    return [1, 4].includes(props.item.id_grupo_faturamento) ? (
        <table width={130} style={{ margin: 2 }}>
            <tbody>
                <tr>
                    <td style={{ padding: "0px 4px", border: "1px solid #22222250" }}>
                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>P: {Math.round(props.item.saldo_geracao_ponta || 0)}</div>
                    </td>
                </tr>
                <tr>
                    <td style={{ padding: "0px 4px", border: "1px solid #22222250" }}>
                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>FP: {Math.round(props.item.saldo_geracao_fora_ponta || 0)}</div>
                    </td>
                </tr>
                <tr>
                    <td style={{ padding: "0px 4px", border: "1px solid #22222250" }}>
                        <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                            <span className="pr-1">Total: {Math.round(props.item.saldo_geracao || 0)}</span>
                            {icon}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    ) : (
        <div style={{ border: "1px solid #22222250", margin: 2 }}>
            <span className="pr-1">{Math.round(props.item.saldo_geracao || 0)}</span>
            {icon}
        </div>
    );
}
